export default __webpack_public_path__ + "static/media/img1.cef67539.jpg";